export default {
  siteName:'工程项目助手',
  header:{
    breadcrumb:{
      FrontPage:'首页'
    },
    tooltip:{
      Screenfull:'全屏显示',
      Sketch:'互动画板',
      wireless:'内网传输',
      Mindmap:'思维导图',
      Language:'语言切换',
      Excel:'Excel'
    },
    dropdown:{
      CN:'中文',
      EN:'英文',
      Logout:'退出登录',
      Password:'修改密码',
    }
  },
  searchBox:{
    Placeholder_1:'请输入搜索关键字',
    Placeholder_2:'查询类别',
    Message_1:'请先选择搜索类别!',
    Message_2:'keys或value不能为空!'
  },
  selector:{
    Category:{
      Placeholder:'请选择分类...',
    }
  },
  tags:{
    name:'标签'
  },
  route: {
    Quality:'质量管理',
    HSE:'HSE管理',
    Collaboration:'协作中心',
    MarketInfo:'市场动态',
    Email:'我的邮箱',
    Location:'位置状态',
    Invoice:'票据管理',
    Organization:'组织架构',
    Office:'Office模板',
    Cost:'费用管理',
    CloudBucket:'云盘存储',
    Customer:'客户管理',
    GoodsList:'物料管理',
    ContactList:'通讯名录',
    Procurement:'采办管理',
    Storage:'仓储管理',
    Administration:'综合管理',
    Information:'信息管理',
    Tools:'常用工具',
    Settings:'系统设置',
    FrontPage:'我的首页',
    Dashboard:'数据中心',
    Scheduler:'日程安排',
    401:'401',
    Password:'密码修改',
    Sketch:'互动白板',
    Mindmap:'思维导图',
    Chat:'聊天室'
  },
  tagsView: {
    CloseAll: '关闭所有'
  },
  buttons:{
    Add:'新增数据',
    AddTemp:'新增模板',
    ImportExcel:'Excel导入',
    ExportExcel:'Excel导出',
    Import:'导入',
    Export:'导出',
    BatchDelete:'删除行',
    UploadFile:'上传文件',
    BatchDownload:'批量下载',
    Operation:'操作按钮',
    Preview:'预览',
    Public:'公开',
    Private:'私有',
    Download:'下载',
    Edit:'编辑',
    Delete:'删除',
    Submit:'提交',
    Cancel:'取消',
    Confirm:'确定',
    Publish:'发布',
    WithDraw:'撤回',
    Close:'关闭',
    Print:'打印'
  },
  noticeMessage:{
    SaveSuccess:'保存成功',
    ModifySuccess:'修改成功',
    UploadSucess:'上传成功!',
    DeleteSuccess:'删除成功',
    TipContent:'确定要删除',
    Tips:'提示',
    SubmitErr:'未提交成功，表单填写不完整',
    BatchSelect:'请先选择要删除的行',
    BatchDelete:'是否确定要删除选中的行',
    UnSelect:'请先选择项目'
  },
  quality:{
    tabTitle:{
      ITP:'质量计划',
      Supervision:'质量监督',
      Record:'质量记录'
    },
  },
  task:{
    tabTitle:{
      Scheduler:'我的任务',
      GanttChart:'我的计划',
    }
  },
  hse:{
    tabTitle:{
      JSA:'作业风险分析',
      Record:'监督记录',
      WorkPermit:'作业许可',
      Report:'安全报告'
    }
  },
  cloudBucket:{
      Item:'序号',
      FileName:'文件名称',
      FileType:'文件格式',
      FileSize:'文件大小',
      FolderName:'文件夹',
      Creator:'创建者',
      CreateTime:'创建时间',
      IsPublic:'公开状态',
      Operation:'操作'
  },
  office:{
      Excel:'Excel模板',
      Item:'序号',
      ID:'模板编号',
      FileName:'文件名称',
      Creator:'创建者',
      CreateTime:'创建时间',
      Operation:'操作',
      Back:'返回',
      Save:'保存数据',
      Loading:'拼命加载中...',
      SelectTemp:'请选择模板'
  },
  procurement:{
    Inquiry:'采购询价',
    ID:'询价编号',
    Item:'序号',
    Name:'询价名称',
    Creator:'创建者',
    CreateTime:'创建时间',
    Operation:'操作',
},
  adminHR:{
    tabTitle:{
      Personnel:'人员管理',
      Asset:'资产管理',
      Meeting:'会议管理',
      Vehicle:'车辆管理',
    },
    table:{
      Item:'序号',
      Name:'姓名',
      Creator:'创建者',
      CreateTime:'创建时间',
      Operation:'操作'
    }
  },
  information:{
    tabTitle:{
      News:'新闻中心',
      Notice:'公告发布',
      DailyReport:'工作日志',
      BBS:'社区论坛'
    },
    table:{
      Item:'序号',
      Title:'标题',
      Creator:'创建人',
      CreateTime:'创建时间',
      Status:'状态',
      Operation:'操作',
      Content:'内容',
      Published:'已发布',
      Ready:'待发布',
      Avatar:'图片',
      IsSwiper:'是否轮播'
    },
    dialog:{
      Edit:'编辑',
      Editor:'责任编辑',
      NoticeTitle:'公告标题',
      NewsTitle:'新闻标题',
      DailyReport:'工作日志',
      NewAdd:'新增',
      Placeholder_1:'请填写标题',
      Placeholder_2:'请填写内容',
    }
  },
  contact:{
    Name:'联系人',
    Tag:'标签',
    Company:'公司',
    Department:'部门',
    Position:'职位',
    Creator: '创建人',
    Phone:'联系电话',
    Address:'联系地址',
    Email:'邮箱',
    CreateTime: '创建时间',
    Operation:'操作',
    Item:'序号',
    Edit:'编辑项目',
    NewAdd:'新增项目',
    AddPhone:'新增手机号码',
    dialog:{
      Placeholder_1:'请填写姓名',
      Placeholder_2:'请填写工作单位',
      Placeholder_3:'请填写所属部门',
      Placeholder_4:'请填写现任职位',
      Placeholder_5:'请填写联系手机',
      Placeholder_6:'请填写联系地址',
      Placeholder_7:'请填写电子邮箱',
      Placeholder_8:'请选择共享范围',
    }
  },
  customer:{
    Avatar:'客户标识',
    Name:'客户名称',
    EstablishedDate:'成立日期',
    LegalPerson:'法定代表人',
    Industry:'行业分类',
    SeniorExecutive:'高管',
    RegisteredCapital:'注册资本',
    RegisteredAddress:'注册地址',
    ContributedCapital:'实缴资本',
    Shareholder:'股东',
    BusinessScope:'营业范围',
    ContactPerson:'联系人员',
    ContactPhone:'联系电话',
    ContactAddress:'联系地址',
    ContactEmail:'联系邮箱',
    Website:'网站地址',
    Remark:'备注',
    Tag:'客户标签',
    Creator: '创建人',
    CreateTime: '创建时间',
    Operation:'操作',
    Item:'序号',
    Edit:'编辑项目',
    NewAdd:'新增项目',
    Relationship:'客户关系',
    tabPane:{
      Title_1:'基本信息',
      Title_2:'股东高管信息',
      Title_3:'联系方式',
      SubTitle_1:'添加股东信息',
      SubTitle_2:'添加高管信息',
    },
    dialog:{
      Placeholder_1:'请输入客户名称',
      Placeholder_2:'请输入成立日期',
      Placeholder_3:'请输入法定代表人',
      Placeholder_4:'请输入注册资本',
      Placeholder_5:'请输入实缴资本',
      Placeholder_6:'请输入注册地址',
      Placeholder_7:'请输入股东名称',
      Placeholder_8:'请输入股份比例',
      Placeholder_9:'请输入高管职务',
      Placeholder_10:'请输入高管姓名',
      Placeholder_11:'请输入营业范围',
      Placeholder_12:'请输入联系人',
      Placeholder_13:'请输入联系电话',
      Placeholder_14:'请输入联系地址',
      Placeholder_15:'请输入联系邮箱',
      Placeholder_16:'请输入网站地址',
      Placeholder_17:'请输入备注',
      Placeholder_18:'请选择客户关系',
    },
    relationshipOptions:{
      option_1:'潜在客户',
      option_2:'成交客户',
      option_3:'普通客户',
      option_4:'重点客户'
    }
  },
  goodslist:{
      Creator:'创建人',
      CreateTime:'创建时间',
      Operation:'操作',
      Item:'序号',
      Edit:'编辑项目',
      NewAdd:'新增项目',
      Remark:'备注',
      RemarkPlaceholder:'请输入备注',
      ID:'物料编号',
      Avatar:'物料图片',
      Description:'物料描述',
      AlarmLower:'低库存报警',
      MeasureUnit:'计量单位',
      Tag:'物料标签',
      Name:'物料名称',
      Spec:'规格型号',
      Category:'物料分类',
      QRcode:'二维码',
      dialog:{
        Placeholder_1:'请输入物料具体描述',
        Placeholder_2:'请设定低库存报警值',
      },
      rules:{
        Placeholder_1:'请填写物料名称',
        Placeholder_2:'请填写物料编号',
        Placeholder_3:'请选择物料分类',
        Placeholder_4:'请填写规格型号',
        Placeholder_5:'请选择计量单位',
      }
  },
  storage:{
    Warehouse:'仓库列表',
    StockIn:'入库作业',
    StockOut:'出库作业',
    Stock:'实时库存',
    Creator:'创建人',
    CreateTime:'创建时间',
    Operation:'操作',
    Item:'序号',
    Edit:'编辑项目',
    NewAdd:'新增项目',
    Remark:'备注',
    RemarkPlaceholder:'请输入备注',
    warehouse:{
      ID:'仓库编号',
      Name:'仓库名称',
      Placeholder_1:'请输入仓库名称'
    }
  },
  settings:{
    tabTitle:{
      OperationLog:'操作日志',
      Category:'分类设置',
      AdminUser:'用户设置',
      Permission:'权限设置',
      Icon:'图标中心',
      IconFont:'阿里图标',
      ElementUI:'饿了么图标'
    },
    table:{
      //log
      Item:'序号',
      Avatar:'头像',
      UserName:'用户名',
      NickName:'昵称',
      OperationTime:'操作时间',
      //category
      ParentName:'上级分类',
      ChildName:'下级分类',
      Operation:'操作',
      Creator:'创建人',
      CreateTime:'创建时间',
      //adminuser
      Role:'角色名称',
      Password:'密码',
      Description:'描述',
      RoleSetting:'角色设置'
    },
    dialog:{
      Edit:'编辑',
      NewAdd:'新增',
      Placeholder_1:'请选择上级分类',
      Placeholder_2:'请选择下级分类',
      Placeholder_3:'请输入菜单名称',
      Placeholder_4:'请输入菜单标签',
      Placeholder_5:'请输入菜单路由',
      Placeholder_6:'请输入菜单图标',
      Placeholder_7:'请输入用户名',
      Placeholder_8:'请输入用户昵称',
      Placeholder_9:'请输入密码',
      Placeholder_10:'请输入角色名称'
    }
  },
  login:{
    Title:'项目管理助手',
    Confirm:'登 陆',
    Placeholder_1:'请输入用户名',
    Placeholder_2:'请输入密码'
  }
}
